import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import giftReducer from './slices/giftSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    gift: giftReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
